import React from 'react'
import { Link } from 'react-router-dom'

const OurServices = () => {
  const ourservicesobj = [
    {
      id: 1,
      atag: "/web-development-company",
      head: "Web Development",
    },
    {
      id: 2,
      atag: "/dot-net-technology-development",
      head: ".Net Technology",
    },
    {
      id: 3,
      atag: "/mobile-app-development-company",
      head: "Mobile App Development",
    },
    {
      id: 4,
      atag: "/outsourcing-software-development-company",
      head: "Software Development",
    },
    {
      id: 5,
      atag: "/cms-development-company",
      head: "CMS Development",
    },
    {
      id: 6,
      atag: "/erp-development-company",
      head: "ERP",
    },
    {
      id: 7,
      atag: "/digital-marketing-company",
      head: "Digital Marketing",
    },
    {
      id: 8,
      atag: "/iot-app-development-company",
      head: "Internet Of Things (IOT)",
    },
    {
      id: 9,
      atag: "/machine-learning-solution",
      head: "Machine Learning",
    },
    {
      id: 10,
      atag: "/ivr-services-provider-in-noida",
      head: "IVR Services",
    },
  ]
  return (
    <>
      <section className="services-area pt-60 pb-60 bg-f7fafd serv-area-cus">
        <div className="container">
          <div className="row h-100 justify-content-center align-items-center d-sm-flex">
            <div className="col-lg-6 col-md-12 services-content oredr-lg-1 order-md-1 order-sm-2">
              <div className="section-title">
                <h2 className='fontkumbh'>Best in Class Services for Web, Mobility and Digital Marketing</h2>
                <div className="bar" />
                <p className="text-justify">
                  Alobha Technologies offers wide range of services to assist large
                  organisations or associations to work smarter and make them arrive
                  at their objectives. Explore the professional and expert services we
                  offer.
                </p>
              </div>
              <div className="row">
                {ourservicesobj.map((servicard) => {
                  return <div className="col-lg-6 col-md-6 col-sm-6" key={servicard.id}>
                    <div className="box">
                      <Link to={servicard.atag}>  <i data-feather="monitor" /> {servicard.head} </Link>
                    </div>
                  </div>
                })}

              </div>
            </div>
            <div className="col-lg-6 col-md-12 services-right-image order-lg-2 order-md-2 order-sm-1 my-2">
              <img src="assets/img/Our-Services.webp" className="wow fadeInUp" loading="lazy" data-wow-delay="0.6s" alt="main-pic" style={{ display: "block" }} />
              {/* <iframe width="100%" className='iframeyt' height="550px" src="https://www.youtube.com/embed/QvYgBXb50bs" title="Discover the Secrets of Alobha Technologies with this Introduction Video" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> */}
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default OurServices